/**
 * @param {number} [n = undefined] - Количество
 * @param {Function[]} [titles = undefined] - Массив склонений
 * @description Склонение слова в зависимости от числа. n = 4, titles = ['слово', 'слова', 'слов']
 */
const declOfNum = (n: number, titles: string[]): string => {
	return titles[
		n % 10 === 1 && n % 100 !== 11 ? 0 :
		n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2
]};

export const getDuration = duration => { 
	const hours   = Math.floor(duration / 60);
	const minutes = duration % 60;

	const hoursNamespace   = ['час', 'часа', 'часов'];
	const minutesNamespace = ['минута', 'минуты', 'минут'];

	return minutes ?
		`${hours} ${declOfNum(hours, hoursNamespace)} ${minutes} ${declOfNum(minutes, minutesNamespace)}` :
		`${hours} ${declOfNum(hours, hoursNamespace)}`;
}

export const getDeclOfNum = (itemCount, itemNames) => { 
	return `${itemCount} ${declOfNum(itemCount, itemNames)}`
}

export const localeDate = value => {
	const date = new Date(value);
	const options = {
		day   : 'numeric',
		month : 'long',
		year  : 'numeric'
	};
	const formattedDate = new Intl.DateTimeFormat('ru-RU', options).format(date);

	return formattedDate;
}

export const getPercentage = (value, max) => {
	return value / max * 100;
}